import React, { Component } from "react";
import { Route, NavLink, Link, Routes } from "react-router-dom";
import { withRouter, RenderRoute } from "../../../utils/router";
import { withRequest } from "../../../utils/request";
import Edit from "./Edit";
import Configuraciones from "./Configuraciones";
import Terminos from "./Terminos";
import { getLink } from "../../../utils/helpers";
import Loader from "../../general/Loader";
import DatosBancarios from "./DatosBancarios";

class Layout extends Component {
    state = {
        sucursal: {},
        loading: true,
        sucursales: [],
    };

    componentDidMount() {
        this.getSucursales();
    }

    getSucursales = async (url = null) => {
        const id = parseInt(this.props.match.params.id);
        url = url ? url : "sucursales";
        const sucursales = await this.props.request(url);

        if (sucursales.data) {
            this.setState({
                sucursal: sucursales.data.filter(s => s.id === id)[0],
                sucursales: sucursales.data,
                loading: false,
            });
        }
    };

    render() {
        const { loading, sucursal, sucursales } = this.state;

        if (loading) {
            return <Loader />;
        }

        return (
            <div>
                <div className='page-header'>
                    <Link to={getLink('/sucursales/')}>&laquo; Volver a sucursales</Link>
                    <h1 className='page-title'>
                        Editando {sucursal.nombre}
                    </h1>
                </div>
                <div className='row'>
                    <div className='col-md-3 page-sidebar'>
                        <ul className='list-unstyled page-sidebar__menu'>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/sucursales/${sucursal.id}/editar`
                                    )}
                                    end
                                    className='nav-link'>
                                    Información General
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/sucursales/${sucursal.id}/configuraciones`
                                    )}
                                    end
                                    className='nav-link'>
                                    Configuraciones
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/sucursales/${sucursal.id}/terminos`
                                    )}
                                    end
                                    className='nav-link'>
                                    Términos
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={getLink(
                                        `/sucursales/${sucursal.id}/DatosBancarios`
                                    )}
                                    end
                                    className='nav-link'>
                                    Datos Bancarios
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className='col-md-8 offset-1'>
                        <Routes>
                            <Route
                                path='editar'
                                element={<RenderRoute render={(props) => (
                                    <Edit {...props}
                                        sucursal={sucursal}
                                        sucursales={sucursales}
                                        />
                                )} />}
                            />
                            <Route
                                path='configuraciones'
                                element={<RenderRoute render={(props) => (
                                    <Configuraciones {...props} sucursal={sucursal} />
                                )} />}
                            />
                            <Route
                                path='terminos'
                                element={<RenderRoute render={(props) => (
                                    <Terminos {...props} sucursal={sucursal} />
                                )} />}
                            />
                            <Route
                                path='DatosBancarios'
                                element={<RenderRoute render={(props) => (
                                    <DatosBancarios {...props} sucursal={sucursal} />
                                )} />}
                            />
                        </Routes>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(withRequest(Layout));
